import moment from "moment/min/moment-with-locales";
import { LocalizedString } from "../client";

export type eventType = {
    from: moment.Moment;
    to: moment.Moment;
    title: LocalizedString;
    description: LocalizedString;
    location: string;
    link: string;
    isFullDay?: boolean;
};

export const dungeonEvent: eventType = {
    from: moment("2026-08-21"),
    to: moment("2026-08-28"),
    isFullDay: true,
    title: {
        iv: "Game Development Dungeon",
    },
    description: {
        cs: "Kurz je určen primárně pro studenty nastupující do magisterského studijního plánu „Vývoj Her“. Jedná se o týdenní blokovou výuku s cílem seznámit studenty s oblastí vývoje her a představit jim specifika toho studijního plánu na FI MUNI. Výuka probíhá především formou workshopů a diskuzí, součástí je i dvoudenní game-jam.",
        en: 'The course is intended primarily for students entering the "Game Development" master\'s study plan. It is a weekly block class with the aim of introducing students to the areas of game development and introducing them to the specifics of the study plan at FI MUNI. The teaching takes place mainly in the form of workshops and discussions, including also two-days game-jam.',
    },
    location: "Dolní Morava",
    link: "/courses/dungeon",
};
